import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';
import { isTexasZipCode } from '../utils/texasZipCode';
import './QualificationPage.css';

function QualificationPage() {
  const [stage, setStage] = useState<'qualify' | 'notQualified'>('qualify');
  const [insuranceType, setInsuranceType] = useState<'renters' | 'car' | 'pet' | 'home'>('renters');
  const [zipCode, setZipCode] = useState('');
  const [notificationEmail, setNotificationEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notificationSuccess, setNotificationSuccess] = useState(false);
  const navigate = useNavigate();

  const handleQualify = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (zipCode.length !== 5 || !/^\d+$/.test(zipCode)) {
      setError('Please enter a valid 5-digit zip code');
      setLoading(false);
      return;
    }

    if (isTexasZipCode(zipCode)) {
      sessionStorage.setItem('insuranceType', insuranceType);
      sessionStorage.setItem('zipCode', zipCode);
      if (insuranceType === 'car') {
        navigate('/insurance/car');
      } else if (insuranceType === 'pet') {
        navigate('/insurance/pet');
      } else if (insuranceType === 'home') {
        navigate('/insurance/home');
      } else {
        navigate('/insurance/new');
      }
    } else {
      setStage('notQualified');
    }

    setLoading(false);
  };

  const handleNotificationSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setNotificationLoading(true);

    try {
      await client.post('/insurance/waitlist', {
        email: notificationEmail,
        insuranceType,
        zipCode,
      });
      setNotificationSuccess(true);
      setNotificationEmail('');
      setTimeout(() => {
        setStage('qualify');
        setZipCode('');
        setNotificationSuccess(false);
      }, 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to sign up for notifications');
    } finally {
      setNotificationLoading(false);
    }
  };

  return (
    <div className="container qualification-page">
      {stage === 'qualify' && (
        <div className="card" style={{ maxWidth: '500px', margin: '3rem auto' }}>
          <div className="card-header">Let's Get Started</div>
          <p style={{ color: '#4B5563', marginBottom: '1.5rem' }}>
            We&apos;re currently available for renters, home, car, and pet insurance in Texas. Check your eligibility.
          </p>

          <form onSubmit={handleQualify}>
            {error && <div className="alert alert-error">{error}</div>}

            <div className="form-group">
              <label htmlFor="insuranceType">Insurance Type</label>
              <select
                id="insuranceType"
                value={insuranceType}
                onChange={(e) => setInsuranceType(e.target.value as 'renters' | 'car' | 'pet' | 'home')}
              >
                <option value="renters">Renters Insurance</option>
                <option value="home">Home Insurance</option>
                <option value="car">Car Insurance</option>
                <option value="pet">Pet Insurance</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="zipCode">Zip Code</label>
              <input
                id="zipCode"
                type="text"
                maxLength={5}
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value.replace(/\D/g, ''))}
                placeholder="77001"
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Checking...' : 'Check Eligibility'}
            </button>
          </form>
        </div>
      )}

      {stage === 'notQualified' && (
        <div className="card" style={{ maxWidth: '500px', margin: '3rem auto' }}>
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📍</div>
            <h2>Coming Soon!</h2>
            <p style={{ color: '#4B5563', marginBottom: '2rem' }}>
              We currently offer renters, home, car, and pet insurance only in Texas. Your zip code ({zipCode}) is outside our
              coverage area, but we're working hard to expand! Enter your email and we'll notify you as soon as we
              launch in your area.
            </p>

            {notificationSuccess && (
              <div className="alert alert-success">✓ Thanks! We'll notify you soon.</div>
            )}

            {!notificationSuccess && (
              <form onSubmit={handleNotificationSignup}>
                {error && <div className="alert alert-error">{error}</div>}

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    id="email"
                    type="email"
                    value={notificationEmail}
                    onChange={(e) => setNotificationEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ width: '100%' }}
                  disabled={notificationLoading}
                >
                  {notificationLoading ? 'Signing Up...' : 'Notify Me'}
                </button>
              </form>
            )}

            <button
              className="btn btn-secondary"
              style={{ width: '100%', marginTop: '1rem' }}
              onClick={() => {
                setStage('qualify');
                setZipCode('');
                setError('');
              }}
            >
              Try Another Zip Code
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default QualificationPage;
